<script>
  import geojson2h3 from "geojson2h3";
  import * as turf from "@turf/turf";
  import * as ss from "simple-statistics";
  import {
    radioCheck,
    isCalculate,
    totalPopulation,
    totalPopulation_OZP_TZ,
    totalJobs_OZP_TZ,
    totalJobs,
    averageAge,
    averageCommute,
    averageWalk,
    averageDeprivation,
    serverURL,
    LoadingBarValue,
    drawClicked,
    topZonesStore,
    top10Count,
  } from "../../../store.js";

  export let poly;
  export let map;
  export let Draw;
  export let bufferDrawzones;
  let topZones;
  $: topZones = $topZonesStore;
  let isTopZonesEnabled = true;

  function toggleTopZones() {
    if (isTopZonesEnabled) {
      var data = map.getSource("box")._data.features;
      const values = data.map((obj) => obj.properties[$radioCheck]);
      values.sort((a, b) => a - b);
      var tz = 1 - $topZonesStore / 100;
      var top10 = ss.quantile(values, [0, tz, 1]);

      map.setPaintProperty("box-layer", "fill-opacity", [
        "case",
        [">=", ["get", $radioCheck], top10[1]],
        0.8,
        0.1,
      ]);
    } else {
      // Toggle is disabled, set a fixed fill-opacity of 0.8
      map.setPaintProperty("box-layer", "fill-opacity", 0.8);
    }

    // Toggle the state for next click
    isTopZonesEnabled = !isTopZonesEnabled;
  }

  function toggleText() {
    if ($isCalculate) {
      OPZ();
      calcScheme();
    } else {
      resetScheme();
    }
  }
  function OPZ() {
    if (map.getSource("buffer")) {
      map.removeLayer("buffer");
      map.removeSource("buffer");
    }
    if ($topZonesStore == 0) {
      alert(
        "Use the sliding scale to select how many areas to base the analysis on. The sliding scale ranges from the 5% to the 50%  most suitable areas"
      );
      return;
    }
    if (Draw.getAll().features.length > 0) {
      poly = Draw.getAll();
      getBuffer(poly.features[0].geometry);
    } else {
      alert("No polygon drawn");
    }
  }

  function getBuffer(poly) {
    let cent = turf.centroid(poly);
    let comb = turf.buffer(poly, bufferDrawzones, { units: "kilometers" });

    map.addSource("buffer", {
      type: "geojson",
      data: comb,
    });

    map.addLayer(
      {
        id: "buffer",
        type: "fill",
        source: "buffer",
        layout: {},
        paint: {
          "fill-color": "#45bcbb",
          "fill-opacity": 0.2,
        },
      },
      "gl-draw-polygon-fill-inactive.cold"
    );
    var h3Calc = geojson2h3.featureToH3Set(comb, 10, {
      options: { ensureOutput: true },
    });

    var h3Search = geojson2h3.featureToH3Set(comb, 7, {
      options: { ensureOutput: true },
    });
    fetch(`${$serverURL}api/data/schemeinfo?h3=${h3Search}`)
      .then((response) => response.json())
      .then((responseData) => {
        const h3_polyfill_res10 = responseData.filter((item) =>
          h3Calc.includes(item.h3_polyfill)
        );
        let groupedData = h3_polyfill_res10.reduce((accumulator, current) => {
          const key = current.h3_polyfill_res8;

          if (!accumulator[key]) {
            accumulator[key] = {
              h3_polyfill_res8: key,
              totalPopulation: 0,
              totalJobs: 0,
            };
          }

          accumulator[key].totalPopulation += current.pop || 0;
          accumulator[key].totalJobs += current.jobs || 0;

          return accumulator;
        }, {});
        let groupedArray = Object.values(groupedData);
        $totalPopulation = groupedArray.reduce((accumulator, current) => {
          return accumulator + (current.totalPopulation || 0);
        }, 0);
        $totalJobs = groupedArray.reduce((accumulator, current) => {
          return accumulator + (current.totalJobs || 0);
        }, 0);

        dataSpeedDials("age_15_45", h3_polyfill_res10);
        dataSpeedDials("lessthan10km", h3_polyfill_res10);
        dataSpeedDials("bikewalktowork", h3_polyfill_res10);
        dataSpeedDialsDep("deprived", h3_polyfill_res10);
      });
  }

  function calcScheme() {
    var data = map.getSource("box")._data.features;
    const values = data.map((obj) => obj.properties[$radioCheck]);
    values.sort((a, b) => a - b);
    var tz = 1 - topZones / 100;
    var top10 = ss.quantile(values, [0, tz, 1]);

    var top10Data = data.filter((d) => {
      return d.properties[$radioCheck] >= top10[1];
    });

    var top10Data_h3 = top10Data.map((d) => d.properties.id);

    var h3Calc = geojson2h3.featureToH3Set(poly, 10, {
      options: { ensureOutput: true },
    });

    var commonElements = h3Calc.filter((h3) => top10Data_h3.includes(h3));

    // Count the number of similar entries
    $top10Count = commonElements.length;

    let h3Search;
    var scheme;
    if (turf.area(poly) > 20000000) {
      h3Search = geojson2h3.featureToH3Set(poly, 7, {
        options: { ensureOutput: true },
      });
      scheme = "schemeinfo";
    } else {
      h3Search = h3Calc;
      scheme = "schemeinfo_res10";
    }

    $LoadingBarValue = 1;
    setTimeout(() => {
      $LoadingBarValue = 10;
      fetch(`${$serverURL}api/data/${scheme}?h3=${h3Search}`)
        .then((response) => response.json())
        .then((responseData) => {
          console.log(responseData);
          $LoadingBarValue = 50;

          const h3_polyfill_res10 = responseData.filter((item) =>
            h3Calc.includes(item.h3_polyfill)
          );

          // Simulate a delay to show progress
          setTimeout(() => {
            $LoadingBarValue = 80;

            const groupedData = h3_polyfill_res10.reduce(
              (accumulator, current) => {
                const key = current.h3_polyfill_res8;

                if (!accumulator[key]) {
                  accumulator[key] = {
                    h3_polyfill_res8: key,
                    totalPopulation: 0,
                    totalJobs: 0,
                  };
                }

                accumulator[key].totalPopulation += current.pop || 0;
                accumulator[key].totalJobs += current.jobs || 0;

                return accumulator;
              },
              {}
            );

            // Simulate a delay to show progress
            setTimeout(() => {
              $LoadingBarValue = 99;

              const groupedArray = Object.values(groupedData);

              // Simulate a delay to show progress
              setTimeout(() => {
                $totalPopulation_OZP_TZ = groupedArray.reduce(
                  (accumulator, current) => {
                    return accumulator + (current.totalPopulation || 0);
                  },
                  0
                );

                $totalJobs_OZP_TZ = groupedArray.reduce(
                  (accumulator, current) => {
                    return accumulator + (current.totalJobs || 0);
                  },
                  0
                );

                // Simulate a delay to show progress
                setTimeout(() => {
                  console.log("jobs and pop complete");
                  $LoadingBarValue = 100;

                  // Final progress update
                }, 200);
              }, 200);
            }, 200);
          }, 200);
        });
    }, 200);

    $isCalculate = false;
  }

  function dataSpeedDials(el, h3_polyfill_res10) {
    const tot = h3_polyfill_res10.reduce(
      (accumulator, current) => {
        const tot = current[el] || 0; // Ensure ptal is a number, default to 0 if undefined
        accumulator.sum += tot;
        accumulator.count += current[el] !== undefined ? 1 : 0;
        return accumulator;
      },
      { sum: 0, count: 0 }
    );

    var newTot = tot.count > 0 ? tot.sum : 0;

    const variableMapping = {
      bikewalktowork: averageWalk,
      age_15_45: averageAge,
      lessthan10km: averageCommute,
      deprived: averageDeprivation, // Fallback variable if el is not 'Walk'
    };

    const variableToSet = variableMapping[el] || variableMapping.default;

    variableToSet.set(newTot);
  }
  function dataSpeedDialsDep(el, h3_polyfill_res10) {
    const tot = h3_polyfill_res10.reduce(
      (accumulator, current) => {
        const tot = current[el] || 0; // Ensure ptal is a number, default to 0 if undefined
        accumulator.sum += tot;
        accumulator.count += current[el] !== undefined ? 1 : 0;
        return accumulator;
      },
      { sum: 0, count: 0 }
    );

    var newTot = tot.count > 0 ? tot.sum / tot.count : 0;

    const variableMapping = {
      bikewalktowork: averageWalk,
      age_15_45: averageAge,
      lessthan10km: averageCommute,
      deprived: averageDeprivation, // Fallback variable if el is not 'Walk'
    };

    const variableToSet = variableMapping[el] || variableMapping.default;

    variableToSet.set(newTot);
  }
  function resetScheme() {
    $LoadingBarValue = 0;

    if (map.getSource("buffer")) {
      map.removeLayer("buffer");
      map.removeSource("buffer");
    }

    $drawClicked = false;
    const elements = document.getElementsByClassName("schemeResults");

    // Loop through each element and set its opacity to 0
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.opacity = 0;
    }
    $isCalculate = true;
    document
      .querySelectorAll(".triangle")
      .forEach((element) => element.remove());
    $averageCommute = 0;
    $averageAge = 0;
    $averageDeprivation = 0;
    $averageWalk = 0;
    setTimeout(() => {
      $totalPopulation = 0;
      $totalJobs = 0;
    }, 1000);
    setTimeout(() => {
      document.getElementById("insights").value = "OZP";
    }, 1);
  }
</script>

<!-- <button
  class="topZones"
  style="opacity: {$topZonesStore > 0 ? 1 : 0};"
  on:click={toggleTopZones}
>
  Toggle Top Zones</button
>-->
<button class="calcScheme" id="calcScheme_OZP" on:click={toggleText}>
  {$isCalculate ? "Calculate" : "Reset"}
</button>

<style>
  .calcScheme {
    position: absolute;
    font-size: 12px;
    bottom: 0px;
    right: 0px;
    margin: 10px;
    border-radius: 10px;
  }
  .topZones {
    position: absolute;
    font-size: 12px;
    bottom: 0px;
    left: 0px;
    margin: 10px;
    border-radius: 10px;
  }
</style>
